<template>
  <div class="workflow-type-stats">
    <div
      class="modal workflow-type-stats-modal"
      style="position: absolute !important"
    >
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />
      <div class="modal-card">
        <section class="modal-card-body" :class="$store.state.theme">
          <div class="is-size-4" style="margin-bottom: 8px">
            <p v-if="selected">
              <span class="button is-rounded is-pulled-left is-dark refresh">
                <i class="fa fa-redo fa-sm" @click="getRecentTransactions" />
              </span>
              {{ selected }}
              <button
                class="delete is-large is-pulled-right"
                @click="clear"
              ></button>
            </p>
            <p v-else>Recent Transactions</p>
          </div>
          <div v-if="selected">
            <div v-if="updating" style="padding: 30px">
              <i class="fa fa-cog fa-spin fa-10x" />
            </div>
            <div v-else>
              <a
                v-for="t in transactions"
                :key="t.id"
                class="panel-block"
                :class="{ deleted: t.is_deleted }"
                @click="moreInfo(t)"
              >
                <span class="tag has-text-weight-medium">{{
                  shortDateTime(t.created_at)
                }}</span
                >&nbsp;
                <span class="tag" :style="transactionStyle(t)">
                  <span v-if="t.is_ongoing">
                    <i class="fas fa-spinner fa-spin" />&nbsp;
                  </span>
                  <span v-if="t.driver">
                    <i class="fas fa-shuttle-van" />&nbsp;
                  </span>
                  <span class="has-text-weight-medium">{{ t.state }}</span>
                </span>
                &nbsp;
                <span>{{ customerName(t) }}</span
                >&nbsp;
              </a>
            </div>
          </div>
          <div v-else class="workflow-types">
            <p v-for="w in workflowTypes" :key="w">
              <span class="tag is-medium" @click="select(w)">{{ w }}</span>
            </p>
          </div>
        </section>
      </div>
    </div>

    <fade-transition>
      <WorkflowTransactionDetails
        v-if="selectedTransaction"
        :t="selectedTransaction"
        @close="selectedTransaction = null"
        @update="getRecentTransactions"
      />
    </fade-transition>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import { sounds } from "../functions.js";
import WorkflowTransactionDetails from "@/components/WorkflowTransactionDetails.vue";

export default {
  name: "WorkflowTypeStatsModal",
  components: {
    WorkflowTransactionDetails,
  },
  data() {
    return {
      transactions: [],
      workflow: null,
      selected: null, // Delivery, Sii Lor, Commerce etc
      updating: false,
      workflowTypes: [
        "Private Tuk Tuk",
        "Sii Lor",
        "Public Tuk Tuk",
        // "Songthaew",
        "Motocy",
        "Fleet",
        "Delivery",
        "Commerce",
      ],
      selectedTransaction: null,
    };
  },
  computed: {},
  mounted() {
    console.log("mount WorkflowTypeStatsModal");
    EventBus.$on("WORKFLOW_TYPE_STATS", () => {
      this.transactions = []; // reset
      this.clear();
      // this.getRecentTransactions();
    });
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    clear() {
      this.selected = null;
    },
    // color(i) {
    //   if (i < 4) return "is-link";
    //   return "is-primary";
    // },
    select(workflowType) {
      this.selected = workflowType;
      this.getRecentTransactions();
    },
    customerName(t) {
      if (t.customer.name !== "") return t.customer.name;
      return t.customer.phone_number;
    },
    shortTime(t) {
      var str = new Date(t.created_at).toLocaleTimeString("en-GB");
      return str.slice(0, 5);
    },
    getRecentTransactions() {
      var payload = { type: this.selected, offset: 0 };
      this.updating = true;
      this.$store
        .dispatch("getTransactionsByWorkflowType", payload)
        .then((res) => (this.transactions = res.data))
        .catch((err) => this.apiError(err))
        .finally(() => (this.updating = false));
    },
    date(t) {
      return new Date(t.created_at).getDate();
    },
    transactionStyle(t) {
      var color = "#ff85A8"; //"pink";
      if (t.state === "scheduled") color = "gold";
      var successStates = ["alighted", "completed"];
      if (successStates.includes(t.state)) color = "palegreen";
      var liveStates = [
        "initiated",
        "confirmed",
        "driver_arrived",
        "enroute",
        "ready",
      ];
      if (liveStates.includes(t.state)) color = "#0dd";
      return `background-color: ${color}`;
    },
    green(isOngoing) {
      if (isOngoing) return `background-color: lightgreen`;
      return `background-color: pink`;
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    commerceInfo(t) {
      var YAML = require("json2yaml");
      var ymlText = YAML.stringify(t.data);
      this.$swal({
        title: t.state,
        html: `<div style="text-align:left; white-space:pre-line; font-size:0.8em">${ymlText}</div>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    moreInfo(t) {
      this.selectedTransaction = t;
      // if (t.workflow_type_name === "Commerce") return this.commerceInfo(t);
      // var shortID = this.lastFive(t.id);
      // var updated = new Date(t.updated_at);
      // var timeDiff = Math.round((new Date() - updated) / (1000 * 60));
      // var prettyTime = `${timeDiff} mins ago`;
      // if (timeDiff > 60) {
      //   timeDiff = Math.round(timeDiff / 60);
      //   prettyTime = `${timeDiff} hours ago`;
      // }
      // var createdTime = new Date(t.created_at).toLocaleTimeString("en-GB");
      // var driverName = "None";
      // var driverMobile = "None";
      // if (t.driver) {
      //   driverName = t.driver.name;
      //   driverMobile = t.driver.phone_number;
      // }
      // var customerName = t.customer.name;
      // var customerMobile = t.customer.phone_number;
      // var dropoff = "Unknown";
      // if (t.data.dropoff_stop) dropoff = t.data.dropoff_stop.name;
      // var price = "Free of Charge";
      // if (t.data.fare) price = t.data.fare.price;
      // var cash = "0";
      // if (t.data.fare) cash = t.data.fare.cash;
      // var orderValue = "None";
      // var paymentMethod = "None";
      // if (t.data.delivery) {
      //   orderValue = t.data.delivery.order_value;
      //   paymentMethod = t.data.delivery.payment_method;
      // }
      // var swalOpts = {
      //   title: t.customer.name,
      //   html: `<div style="text-align:left">
      //   State <strong>${t.state}</strong><br>
      //   Customer <strong>${customerName}</strong> (${customerMobile})<br>
      //   Driver <strong>${driverName}</strong> (${driverMobile})<br>
      //   Pickup <strong>${t.data.pickup_stop.name}</strong><br>
      //   Dropoff <strong>${dropoff}</strong><br>
      //   Fare <strong>฿${price} </strong>(${cash} cash)<br>
      //   Order <strong>฿${orderValue} </strong>${paymentMethod}<br>
      //   Created <strong>${createdTime}</strong><br>
      //   Updated <strong>${prettyTime}</strong><br>
      //   Transaction ID <strong>${shortID}</strong><br>
      //   Mobile <strong>${t.customer.phone_number}</strong><br></div>`,
      //   showConfirmButton: false,
      //   showCloseButton: true,
      // };
      // if (t.state === "timed_out") {
      //   swalOpts.showConfirmButton = true;
      //   swalOpts.confirmButtonText = "Retry";
      //   swalOpts.confirmButtonColor = "red";
      // }
      // this.$swal(swalOpts).then((val) => {
      //   if (val.value) this.retryDelivery(t);
      // });
    },
    retryDelivery(t) {
      sounds("mystery_long");
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "initiated", data: { retry: true } },
        })
        .then(() => {
          this.infoToast("We are retrying the delivery request 🤞🏽");
          this.getRecentTransactions();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.dark {
  background-color: black;
  color: grey;
}
.dark .panel-block {
  color: grey;
  border: 1px solid rgba(63, 106, 150, 0.8);
  margin-bottom: -1px;
}
.modal-card-body {
  padding: 10px;
  border-radius: 25px;
  max-width: 600px;
}
.panel-block {
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
  border-radius: 6px;
  padding: 6px;
  /* border: 1px solid grey; */
}
.tag {
  font-size: 0.7em;
}
.panel-block::-webkit-scrollbar {
  display: none;
}
/* .updating {
  float: left;
} */
.workflow-types p {
  margin-bottom: 20px;
}
p .tag {
  width: 170px;
  font-weight: 500;
}
.refresh {
  padding: 10px;
  background-color: rgba(128, 128, 128, 0.2);
  color: white;
}
.deleted {
  background-color: rgba(254, 89, 130, 0.4);
}
</style>